export default () => {
  return [
    {
      value: '1',
      name: '1 Michelin Star and above',
    },
    {
      value: '2',
      name: '2 Michelin Star and above',
    },
    {
      value: '3',
      name: '3 Michelin Star',
    },
    {
      value: '1',
      name: 'Michelin Green Star',
    },
    {
      value: '0',
      name: 'AA Rosettes (All)',
    },
    {
      value: '3',
      name: '3 AA Rosettes and above',
    },
    {
      value: '4',
      name: '4 AA Rosettes and above',
    },
    {
      value: '5',
      name: '5 AA Rosettes',
    },
    {
      value: '0',
      name: 'Les Grandes Tables du Monde',
    },
  ]
}